import React, { Fragment } from "react";
import {
  Features,
  Features2,
  Team,
  Slider,
} from "../../widgets";

import styles from './Home.module.scss';
import Header from './Header/Header';

import { useCustomState } from "../../../state/state";
import { Footer } from '../../layouts';
export default () => {
  const state = useCustomState()[0];

  return (

    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.section}>
            <Header data={state.data.menu} />
          </div>
          <div className={styles.section}>
            <Slider data={state.data.posts} />
          </div>
          <div className={styles.section}>
            <Features2 data={state.data.features2} />
          </div>
          <div className={styles.section}>
            <Team data={state.data.team} />
          </div>
          <div className={styles.section}>
            <Features data={state.data.features} />
          </div>
          <div className={styles.section}>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};
